import { defineStore } from "pinia";
import { orgApi } from "@/utils/Api.util";
import { UploadingFile } from "@/models/UploadingFile.model";
import { File as FileModel } from "@/models/File.model";
import { ApiErrorMessageBag } from "@/stores/errors/ApiErrorMessageBag.ts";
import { FileExternal } from "@/models/FileExternal.model";

import config from '@/config/app.config';

export const useUploadStore = defineStore('upload', {
	state: () => ({
		errors: null as string | null,
		uploading: [] as UploadingFile[],
		currentUpload: null as UploadingFile | null,
	}),

	actions: {
		upload(file: File,  callback: Function, errorCallback: Function) {

			this.errors = null;

			const formData = new FormData();
			formData.append('file', file);

			this.currentUpload = new UploadingFile();
			this.uploading.push(this.currentUpload);

			this.currentUpload.file = file;
			this.currentUpload.uploading = true;
			this.currentUpload.progress = 0;

			if (!this.validFileSize(file)) {

				this.currentUpload.errors = 'MAX_FILE_SIZE_EXCEEDED';

				errorCallback(this.currentUpload.errors);
				return this.currentUpload;
			}

			orgApi.post('files', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				onUploadProgress: (progressEvent) => {
					if (progressEvent.progress) {
						this.currentUpload.progress = progressEvent.progress
					}
				}
			}).then((response) => {
				this.currentUpload.uploading = false;

				try {
					response.data.data.forEach((file: any) => {
						callback(FileModel.mapFromServer(file));
					});
				} catch (e) {
					console.error(e);
				}
			}).catch((error) => {

				this.currentUpload.uploading = false;

				try {
					const validationError = ApiErrorMessageBag.fromAxiosException(error);
					this.currentUpload.errors = validationError.toString();
				} catch (e) {
					this.currentUpload.errors = error.response.data.message;
				}

				if(!this.currentUpload.errors) {
					// fallback error message
					this.currentUpload.errors = 'An error occurred during upload';
				}

				errorCallback(this.currentUpload.errors);

			});

			return this.currentUpload;
		},

		/**
		 * @param file
		 */
		validFileSize(file: File) {

			if (file.size > 1204 * 1024 * config.MAX_FILE_SIZE_MB) {
				return false;
			}

			return true;

		},

		/**
		 * @param service
		 * @param file
		 */
		async addFromExternalStorage(file: FileExternal) {

			const response = await orgApi.post('external-files', {

				name: file.name,
				url: file.url,
				mimeType: file.mimeType,
				service: file.service

			});

			return FileModel.mapFromServer(response.data.data[0]);

		}
	}
});
